import React from 'react';

interface SendImageConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const SendImageConfig: React.FC<SendImageConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-700 leading-relaxed">
        <strong>Como funciona:</strong> Envia uma imagem para o usuário no chat. Informe a URL pública da imagem (JPG, PNG, GIF, etc.). A imagem será exibida diretamente na conversa.
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          URL da Imagem (Link Público)
        </label>
        <input
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="https://exemplo.com/imagem.jpg"
          value={config.imageUrl || ''}
          onChange={(e) => onChange('imageUrl', e.target.value)}
        />
        <div className="mt-2 p-3 bg-blue-50 rounded-md border border-blue-100">
          <p className="text-xs text-blue-800 font-medium mb-1">
            Como pegar o link do Bitrix Drive:
          </p>
          <ol className="text-xs text-blue-700 list-decimal list-inside space-y-1">
            <li>Vá ao Bitrix24 Drive e encontre a imagem</li>
            <li>Clique no arquivo e ative a opção "Link Público"</li>
            <li>Copie o link gerado e cole no campo acima</li>
          </ol>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Legenda (Opcional)
        </label>
        <textarea
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows={2}
          placeholder="Digite uma legenda..."
          value={config.caption || ''}
          onChange={(e) => onChange('caption', e.target.value)}
        />
      </div>
    </div>
  );
};
